'use client';

import type { ReactNode } from 'react';
import {
  EntityListRowErrorBoundary,
  type EntityListRowErrorBoundaryLabels
} from './EntityListRowErrorBoundary';
import {
  EntityListRowRenderErrorPanel,
  type EntityListRowRenderErrorPanelDensity
} from './EntityListRowRenderErrorPanel';

export type EntityListRowCellErrorBoundaryProps = {
  labels: EntityListRowErrorBoundaryLabels;
  children: ReactNode;
  density?: EntityListRowRenderErrorPanelDensity;
  /** Passed to {@link EntityListRowRenderErrorPanel} when the fallback is shown (e.g. grid selection safe area). */
  fallbackClassName?: string;
};

/**
 * One error boundary per cell so a throwing column `render` only replaces that cell,
 * using the same UI as row-level {@link EntityListRowErrorBoundary}.
 */
export function EntityListRowCellErrorBoundary({
  labels,
  density = 'compact',
  fallbackClassName,
  children
}: EntityListRowCellErrorBoundaryProps) {
  return (
    <EntityListRowErrorBoundary
      labels={labels}
      renderFallback={({ error, reset }) => (
        <EntityListRowRenderErrorPanel
          title={labels.title}
          message={error.message}
          tryAgainLabel={labels.tryAgain}
          onTryAgain={reset}
          density={density}
          className={fallbackClassName}
        />
      )}
    >
      {children}
    </EntityListRowErrorBoundary>
  );
}
